import { render, staticRenderFns } from "./TicketCreateNewTicket.vue?vue&type=template&id=567d9b4e&scoped=true&"
import script from "./TicketCreateNewTicket.vue?vue&type=script&lang=js&"
export * from "./TicketCreateNewTicket.vue?vue&type=script&lang=js&"
import style0 from "./TicketCreateNewTicket.vue?vue&type=style&index=0&id=567d9b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d9b4e",
  null
  
)

export default component.exports